module.exports = __webpack_public_path__ + "5d7e6fd54400082c46e6375d6a7d5c41.png";